module.exports = __webpack_public_path__ + "media/country_flags/tc-a4fc5fd8.png";